import { MaybeNull } from 'interfaces'
import { AssetSummaryDTO } from '@ketch-com/figurehead'

export const getDoesAssetSupportHooks = (assetSummary?: MaybeNull<AssetSummaryDTO>) => {
  return (assetSummary?.asset?.resource?.resourceType?.characteristics || []).indexOf(11) !== -1
}
